export default "__VITE_PUBLIC_ASSET__4b3d40e0__"